<template>
    <div>
        <div class="modal fade" id="modelTemplateModal" tabindex="-1" role="dialog" aria-labelledby="modelTemplateModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="modelTemplateModalLabel">Data Model Templates</h5>
                        <button type="button" class="btn-close" @click="noHandler" aria-label="Close">

                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="alert alert-success" role="alert">
                            Jump start your development by importing the following tables into your application.
                        </div>

                        <h4>{{appTemplate.name}} Tables</h4>

                        <div v-for="model in models" class="card shadow mb-3">
                            <div class="card-body">
                                <h5 class="card-title">{{model.name}}</h5>
                                <div v-for="field in model.fields">
                                    <i class="fad me-2 mt-1 text-primary" :class="getClass(field)"> </i>{{field.name}}
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="yesHandler" >Import Tables</button>
                        <button type="button" class="btn btn-secondary " @click="noHandler">cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'ModelTemplateModal',
        props: {
            yesEvent: Function,
            appTemplate: Object
        },
        data () {
            return {
                model: webase.model,
                models: [],
                currentModal: null,
                modalElement: null,
            }
        },
        mounted() {
            this.modalElement = document.getElementById('modelTemplateModal')
            this.currentModal = new bootstrap.Modal(this.modalElement)

            this.modalElement.addEventListener('hidden.bs.modal', this.onModalHidden)

            this.currentModal.show()

            this.models = this.appTemplate.tables
        },
        beforeUnmount() {
            this.modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden)
        },
        methods: {
            onModalHidden() {
                this.$emit('noEvent')
            },
            noHandler(e) {
                this.currentModal.hide()
            },
            yesHandler(e) {

                // call the parent's "yesEvent"
                if(this.yesEvent) {
                    this.yesEvent()
                }
                // hide the modal
                this.noHandler()
            },
            getClass(field) {
                return webase.utils.ui.getClass(field)
            }
        }
    }
</script>
